// extracted by mini-css-extract-plugin
export default {"activeBtn":"PrintTypeBtn_activeBtn__qU0Os","noActive":"PrintTypeBtn_noActive__9nQAT","btn":"PrintTypeBtn_btn__MCAam"};